import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'reactstrap';
import { api } from 'services/api';

export const NoteItem = ({ note, endpoint, reload, userIsAdmin, showToast }) => {
    const containerRef = useRef(null);
    const noteTextRef = useRef(null);
    const noteUserRef = useRef(null);

    const [hovered, setHovered] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [valueEdit, setValueEdit] = useState({ comment: note.comment });
    const [noteExpanded, setNoteExpanded] = useState(false);
    const [isTextOverflowing, setIsTextOverflowing] = useState(false);

    useEffect(() => {
        const textElement = noteTextRef.current;
        const containerElement = containerRef.current;
        const userElement = noteUserRef.current;
        if (textElement && containerElement && userElement) {
            setIsTextOverflowing(textElement.scrollHeight > (containerElement.scrollHeight - userElement.scrollHeight));
        }
    }, []);

    const handleInput = (e) => {
        if (e.target.value > 450) return;
        setValueEdit({ ...valueEdit, [e.target.name]: e.target.value });
    };

    const handleExpanded = () => setNoteExpanded((prev) => !prev);

    const openEditMode = () => { setEditMode(true); handleExpanded(); };
    const closeEditMode = () => { setEditMode(false); handleExpanded(); };

    const updateNote = (e) => {
        e.preventDefault();
        if (valueEdit.comment.length === 0) {
            showToast('warning', 'Insira um comentário para atualizar a nota!');
            return;
        }
        api.patch(`/process/notes/${note.id}/`, valueEdit).then(async () => {
            showToast('success', 'Nota atualizada com sucesso!');
            closeEditMode();
            await reload(endpoint, { loader: false });
        }).catch((error) => {
            showToast('error', 'Erro ao alterar nota...');
            console.error(error);
        });
    };

    const deleteNote = () => {
        api.delete(`/process/notes/${note.id}/`).then(async () => {
            showToast('success', 'Nota deletada com sucesso!');
            closeEditMode();
            await reload(endpoint, { loader: false });
        }).catch((error) => {
            showToast('error', 'Erro ao deletar nota...');
            console.error(error);
        });
    };

    const showActions = hovered && !editMode && !confirmDelete;

    return (
        <div
            style={{ justifyContent: "flex-start" }}
            className={`container-note-duelist-modal ${noteExpanded ? "container-note-duelist-modal-expanded" : ""}`}
            ref={containerRef}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className="note-duelist-modal">
                <div className='autor-note-duelist-modal'>
                    <div ref={noteUserRef} className='text-note-duelist-modal' style={{ flex: 1 }}>
                        {note.user.first_name.length > 0
                            ? `${note.user.first_name} ${note.user.last_name}`
                            : `${note.user.username}`}
                        {localStorage.getItem("AUTHOR_ID") === note.user_id.toString() ? " (you)" : null}
                    </div>

                    {note.created_at && (
                        <span className='datetime-note-duelist-modal'>
                            {new Date(note.created_at).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </span>
                    )}

                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center', minHeight: '30px' }}>
                        {confirmDelete ? (
                            <>
                                <Button color="danger" onClick={deleteNote} size="sm">Confirmar</Button>
                                <Button color="default" onClick={() => setConfirmDelete(false)} size="sm">Cancelar</Button>
                            </>
                        ) : userIsAdmin() && (
                            <div style={{ opacity: showActions ? 1 : 0, transition: 'opacity 0.15s', pointerEvents: showActions ? 'auto' : 'none', display: 'flex', gap: '4px' }}>
                                {isTextOverflowing && (
                                    <Button color={noteExpanded ? "default" : "primary"} onClick={handleExpanded} size="sm">
                                        {noteExpanded ? 'Menos' : 'Mais'}
                                    </Button>
                                )}
                                <Button color="default" onClick={openEditMode} size="sm">Editar</Button>
                                <Button color="danger" onClick={() => setConfirmDelete(true)} size="sm">Deletar</Button>
                            </div>
                        )}
                    </div>
                </div>

                {editMode ? (
                    <form onSubmit={updateNote}>
                        <textarea
                            name="comment"
                            value={valueEdit.comment}
                            onChange={handleInput}
                            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #dee2e6' }}
                        />
                        <Button type="submit" size="sm" color="primary">Salvar</Button>
                        <Button type="button" size="sm" color="default" onClick={closeEditMode}>Cancelar</Button>
                    </form>
                ) : (
                    <p ref={noteTextRef}>{note.comment}</p>
                )}
            </div>
        </div>
    );
};

export default NoteItem;
